<template>
    <TheGuidelinesLayout
        v-if="guideline"
        data-wide
    >
        <h2>Panel</h2>

        <BaseMemberList
            v-if="guideline.panel.length"
            :parent-id="Number(guideline.panel[0].id)"
            :show-conflict-of-interest="true"
        />

        <p v-else>
            There is no information available about this guideline's panel at this moment.
        </p>
    </TheGuidelinesLayout>
</template>

<script setup>
const { activeSite } = useMultisite();
const props = defineProps({
    guideline: {
        type: Object,
        required: true,
        default: null
    }
});

const seo = computed(() => {
    if (!props.guideline.seo) {
        return;
    }

    return useSeo(props.guideline?.seo, props.guideline, undefined, activeSite);
});

// todo - guidelines are not yet available for multisite's
useHead({
    title: `Panel of the ${props.guideline.title} guideline - Uroweb`,
    meta: seo.value?.meta ?? null
});
</script>
